import { useMemo } from 'react';

import { Reaction } from '../lib/reaction';
import { ReactionType } from '../types';

export const useReactionTypes = () => {
	return useMemo<Reaction[]>(() => {
		return [
			Reaction.fromType(ReactionType.Like),
			Reaction.fromType(ReactionType.Love),
			Reaction.fromType(ReactionType.Celebrate),
			Reaction.fromType(ReactionType.Amaze),
			Reaction.fromType(ReactionType.Laugh),
		];
	}, []);
};
